import { ConfigError } from 'AuthSdk/errors';

/**
 * Returns the public-facing auth issuer URL for the current product.
 *
 * Precedence:
 * 1. `NEXT_PUBLIC_BOMDISOFT_AUTH_URL` — canonical Bomdisoft-platform variable.
 * 2. `NEXT_PUBLIC_CLEPIT_AUTH_URL` — clepit-app legacy variable retained for
 *    backwards-compat during the Track 2 migration. Remove once clepit-app
 *    migrates to the bomdisoft-prefixed name.
 */
export const getAuthBaseUrl = (): string => {
  const url = process.env.NEXT_PUBLIC_BOMDISOFT_AUTH_URL ?? process.env.NEXT_PUBLIC_CLEPIT_AUTH_URL;
  if (!url) throw new ConfigError('NEXT_PUBLIC_BOMDISOFT_AUTH_URL or NEXT_PUBLIC_CLEPIT_AUTH_URL');
  return url.replace(/\/$/, '');
};
